export function buildDicomizeFormData(files: File[]): FormData {
	const form = new FormData();
	for (const file of files) {
		const name = `${file.name}`;
		form.append("files", file, name);
	}

	return form;
}